export default __webpack_public_path__ + "static/media/long-paragraph.eff0e1f9.svg";